import { render, staticRenderFns } from "./ContactSelectionDialog.vue?vue&type=template&id=2a43e73d"
import script from "./ContactSelectionDialog.vue?vue&type=script&lang=ts"
export * from "./ContactSelectionDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContactSelectionDialog.vue?vue&type=style&index=0&id=2a43e73d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports